export const cleanWhitespace = (words: string): string => {
    return words === null ? "" : words.trim().split(/\s+/).join(" ");
};
